import { useEffect, useState, forwardRef, useRef } from 'react';
import { Grid, Typography, Button, IconButton } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import axios from 'axios';
import generateRandomString, { compressImage, getGeoCountryCode } from 'common';
import {
	getCookie,
	setCookie,
	authHeaders,
	whichAppOsIsThis,
	isLoggedIn,
	setGlobalToastMessage,
	handleUnauthorizedAccess,
	setInLocalStorage
} from 'common';
import { useNavigate } from 'react-router-dom';
import urls from 'backend_urls';
import Loader from 'components/Loader';
import VerifiedIcon from '@mui/icons-material/Verified';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import { useTheme } from '@mui/material/styles';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import UpdateUserDetails from './forms/UpdateUserDetails';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import PersonIcon from '@mui/icons-material/Person';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import CallIcon from '@mui/icons-material/Call';
import LogoutIcon from '@mui/icons-material/Logout';
import DeleteIcon from '@mui/icons-material/Delete';
import background from 'assets/images/backgrounds/account-bg.png';
import { Language } from 'language';
import { useSelector, useDispatch } from 'react-redux';
import { User } from 'store/reducers/userSlice';
import { toast } from 'react-toastify';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';


const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const MyAccount = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch()
	const [loading, setLoading] = useState(false);
	const [pictureUploaded, setPictureUploaded] = useState(null);
	const [myAccountData, setMyAcountData] = useState(null);
	const [isCountryChanged, setIsCountryChanged] = useState(true);
	const [updateUserDetailsData, setUpdateUserDetailsData] = useState(null);

	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [countryOpen, setCountryOpen] = useState(false);
	const [selectedCountry, setSelectedCountry] = useState(null);
	const countries = useSelector(state => state.activeCountry.data)
	const fileInputRef = useRef(null);
	const userData = useSelector(state => state.user.data)

	useEffect(() => {
		if (isCountryChanged || pictureUploaded) dispatch(User());
	}, [isCountryChanged, pictureUploaded]);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		setCountryOpen(false);
	};

	const toggleDrawer = (newOpen, value) => () => {
		setModalOpen(newOpen);
		openUserDataPopupBox(value);
	};

	useEffect(() => {
		(async () => {
			if (myAccountData) {
				if (!myAccountData.is_pdpa_done && myAccountData.country == "Thailand") navigate('/pdpa')
			}
		})();
	}, [myAccountData]);


	const [page_data, setPageData] = useState({
		page_name: 'My Account',
		data_label: 'Personal Info',
		avatar: 'https://img.freepik.com/free-psd/3d-illustration-person-with-sunglasses_23-2149436188.jpg',

		data: {
			name: { label: Language.label.name, value: '-', link_to: 'edit_name', icon: PersonIcon },
			mobile: { label: Language.label.mobile, value: '-', link_to: 'edit_number', icon: CallIcon },
			email: { label: Language.label.email, value: '-', link_to: 'edit_email', icon: AlternateEmailIcon },
			vehicle_number: { label: Language.label.vehicle_number, value: null, link_to: 'edit_vehicle_number', icon: AlternateEmailIcon }
		}
	});

	const updateValue = (key, newValue) => {
		if (key !== "vehicle_number" && (newValue === null || newValue === undefined)) {
			newValue = '-';
		}
		setPageData((page_data) => ({
			...page_data,
			data: {
				...page_data.data,
				[key]: {
					...page_data.data[key],
					value: newValue
				}
			}
		}));
	};

	const callDeleteAccount = async () => {
		try {
			await axios
				.get(`${urls.deleteAccount}`, { headers: authHeaders() })
				.then((response) => {
					handleClose();
					setLoading(false);
					setGlobalToastMessage('success', response.data.message);
					window.location.reload();
				})
				.catch((error) => {
					setLoading(false);
					console.error('error', error.response.data);
				});
		} catch (error) {
			// Handle error
			console.error('Error fetching data:', error);
		}
	};

	const handleChangeCountry = async () => {
		setIsCountryChanged(false)
		try {
			setLoading(true);
			await axios
				.get(`${urls.updateUserDetails}country/${selectedCountry}/`, { headers: authHeaders() })
				.then(() => {
					setLoading(false);
					setCountryOpen(false);
					setIsCountryChanged(true)
				})
				.catch(() => {
					setLoading(false);
					setCountryOpen(false);
					setGlobalToastMessage('error', 'can not change country.');
				});
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	}

	const fetchData = async () => {
		try {
			let token = getCookie('token');
			if (token && userData.name !== "Guest") {
				if (!userData.email) navigate('/onboarding/email')
				if (userData !== null && userData !== undefined) setMyAcountData(userData);
				updateValue('name', userData.name);
				updateValue('email', userData.email);
				updateValue('mobile', userData.phone);
				updateValue('vehicle_number', userData.vehicle_number);

				if (
					userData.picture !== null &&
					userData.picture !== undefined &&
					userData.picture !== '' &&
					userData.picture !== '-'
				)
					setPageData((page_data) => ({
						...page_data,
						avatar: userData.picture
					}));
				//If mobile app get FCM
				let app = whichAppOsIsThis();
				let auth_token = isLoggedIn();
				if (app === 'android')
					window.location.href = `https://com.terracharge.dione.android/####getfcm####${auth_token}`;
				else if (app === 'ios')
					window.location.href = `https://com.terracharge.hyperion.ios/####getfcm####${auth_token}`;
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};


	useEffect(() => {
		if (isCountryChanged || pictureUploaded) {
			fetchData();
		}
	}, [isCountryChanged, pictureUploaded, userData]);

	const verifyEmail = async () => {
		try {
			await axios
				.get(`${urls.verifyEmail}`, { headers: authHeaders() })
				.then(() => {
					toast.success('Email has been sent, please check your mailbox');
				})
				.catch(() => {
					toast.error('can not sent email.');
				});
		} catch (error) {
			// Handle error
			console.error('Error fetching data:', error);
		}
	}

	const handleImageUpload = (event) => {
		const file = event.target.files[0];
		if (file) {
			const imageUrl = URL.createObjectURL(file);
			UploadImage(event)
		}
	};

	const handleClick = () => {
		fileInputRef.current.click();
	};

	const UploadImage = async (event) => {
		const file = event.target.files[0];
		let quality = 0.7;
		let compressedImage = file;
		if (file) {
			do {
				compressedImage = await compressImage(compressedImage, quality);
				quality -= 0.1;
			} while ((compressedImage.size / 1024) > 700);
			setPictureUploaded(false)
			try {
				const formData = new FormData();
				formData.append('file', compressedImage);
				const response = await axios.post(urls.profilePicUpload, formData, {
					headers: {
						...authHeaders(),
						'Content-Type': 'multipart/form-data',
					},
				});
				if (response.status) {
					toast.success('Profile Picture successfully! uploaded');
					setPictureUploaded(true)
				} else {
					toast.error('Upload failed. Please try again!');
				}
			} catch (error) {
				toast.error(`Error: ${error.response?.data?.message || 'Please Retry!'}`);
				console.error(error);
			}
		}
	};



	const MyAccountSectionTop = () => {
		return (
			<Grid container spacing={3}>
				<Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
					<Grid
						container
						style={{ backgroundImage: `url(${background})`, backgroundSize: 'cover', height: 100, borderRadius: 5 }}
					>
						<Grid item xs={12}>
							<IconButton
								color="error"
								aria-label="delete"
								// sx={{ position: 'fixed', top: 10, right: 10, zIndex: 99  }}
								onClick={handleClickOpen}
							>
								<DeleteIcon />
							</IconButton>
						</Grid>
						<Grid item xs={12} display="flex" justifyContent="center" alignItems="center" padding={1}>
							<Avatar
								src={page_data.avatar}
								sx={{ width: 60, height: 60, border: '2px solid white', borderRadius: '50%' }}
							/>
							<AddAPhotoIcon title="Upload you Image" sx={{ backgroundColor: "white", fontSize: "25px", padding: "5px", borderRadius: "10px", marginLeft: "-10px", marginBottom: "-20px", zIndex: "99" }} onClick={handleClick} />
						</Grid>
						<input
							ref={fileInputRef}
							type="file"
							accept="image/*,capture=camera"
							style={{ display: 'none' }}
							onChange={handleImageUpload}
						/>
						{/* <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" padding={1}>
							<Typography variant="h3">{page_data.data.name.value}</Typography>
						</Grid> */}
					</Grid>
				</Grid>
			</Grid>
		);
	};

	const openUserDataPopupBox = async (value) => {
		try {
			setUpdateUserDetailsData(value);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	useEffect(() => { }, [updateUserDetailsData]);

	return (
		<>
			{loading ? (
				<Loader></Loader>
			) : (
				<>
					{updateUserDetailsData && myAccountData &&
						((updateUserDetailsData.label === Language.label.email && !myAccountData?.email_verified) || updateUserDetailsData.label === Language.label.name || updateUserDetailsData.label === Language.label.vehicle_number) && (
							<UpdateUserDetails
								value={updateUserDetailsData}
								updateValue={updateValue}
								setUpdateUserDetailsData={setUpdateUserDetailsData}
								toggleDrawer={toggleDrawer}
								open={modalOpen}
							/>
						)}
					<Grid container padding={2} paddingTop={5} rowSpacing={4.5}>
						{MyAccountSectionTop()}
						<Grid
							container
							marginTop={5}
							paddingLeft={2}
							sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', borderRadius: 2 }}
						>
							{/* <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" padding={0}>
								<Typography variant="h5">{page_data.data_label}</Typography>
							</Grid> */}
							{Object.entries(page_data.data).map(([key, value]) => (
								<Grid container key={key + generateRandomString()}>
									<Grid
										item
										xs={12}
										display="flex"
										justifyContent="left"
										alignItems="left"
										padding={0}
										paddingBottom={1}
										sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
									>
										<Grid container paddingTop={2}>
											<Grid item xs={12}>
												<Grid container justifyContent="space-between" alignItems="center">
													<Grid item xs={8} display="flex" justifyContent="left" alignItems="left" padding={0} onClick={toggleDrawer(true, value)}>
														<Grid container>
															<Grid item xs={12} display="flex" justifyContent="left" alignItems="left" padding={0} onClick={toggleDrawer(true, value)}>
																<Typography variant="h6">{value.label}</Typography>
																<span style={{ marginLeft: 10 }}>
																	{value.label === Language.label.mobile &&
																		(myAccountData?.phone_verified ? (
																			<VerifiedIcon sx={{ height: 18, color: 'green' }} />
																		) : (
																			<GppMaybeIcon sx={{ height: 18, color: 'orange' }} />
																		))}
																	{value.label === Language.label.email &&
																		(myAccountData?.email_verified ? (
																			<VerifiedIcon sx={{ height: 18, color: 'green' }} />
																		) : (
																			<GppMaybeIcon sx={{ height: 18, color: 'orange' }} />
																		))}
																</span>
															</Grid>
															<Grid item xs={12} display="flex" justifyContent="left" alignItems="left" padding={0} onClick={toggleDrawer(true, value)}>
																<Typography variant="h6">{value.value} </Typography>
															</Grid>
														</Grid>
													</Grid>
													<Grid item xs={3}>
														{value.label === Language.label.email &&
															!myAccountData?.email_verified && (
																<Button variant="text" color="primary" onClick={() => verifyEmail()}>
																	Verify
																</Button>
															)}
													</Grid>
													<Grid item xs={1} onClick={toggleDrawer(true, value)}>
														<KeyboardArrowRightIcon sx={{ fontSize: '15px' }} />
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							))}
							<Grid container>
								<Grid
									item
									xs={12}
									display="flex"
									justifyContent="left"
									alignItems="left"
									padding={0}
									paddingBottom={1}
									sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
								>
									<Grid container paddingTop={2}>
										<Grid item xs={12}>
											<Grid container>
												<Grid item xs={12} display="flex" justifyContent="left" alignItems="left" padding={0}>
													<Typography variant="h6">Select your region</Typography>
												</Grid>
												<Grid
													item
													xs={12}
													display="flex"
													justifyContent="left"
													alignItems="left"
													padding={0}
													pt={3}
												>
													<Grid container>
														{countries &&
															countries.map((country) => (
																<Grid
																	item
																	xs={4}
																	md={3}
																	lg={1}
																	display="flex"
																	justifyContent="left"
																	alignItems="left"
																	padding={0}
																	key={country.id}
																	onClick={() => {
																		if (myAccountData?.country !== country?.name) {
																			setSelectedCountry(country.id);
																			setCountryOpen(true);
																		}
																	}}
																>
																	<Typography
																		variant="h6"
																		p={1}
																		mb={1}
																		sx={{
																			display: 'flex',
																			border: '0.5px solid grey',
																			borderRadius: '32px',
																			background: myAccountData?.country === country?.name ? "white" : "gray",
																			opacity: myAccountData?.country === country?.name ? 1 : 0.7,
																		}}
																	>
																		<img
																			src={`https://flagcdn.com/w20/${country.short_code.toLowerCase()}.png`}
																			alt="hello"
																			// width="25"
																			style={{ marginRight: '12px', border: '0.1px solid lightgrey' }}
																		/>
																		<Typography variant="caption" sx={{ fontSize: '10px' }}>{country.name} </Typography>
																	</Typography>
																</Grid>
															))}
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						{/* <Grid container pt={2}>
							<Grid item xs={5.5} display="flex" justifyContent="center" alignItems="center">
								<Button
									variant="outlined"
									color="primary"
									disabled={false}
									sx={{
										height: '35px',
										width: '100%',
										fontSize: '15px',
										borderRadius: 10
									}}
									onClick={() => {
										logoutUser();
										navigate('/home');
									}}
								>
									{Language.button.cancel}
								</Button>
							</Grid>
							<Grid item xs={1}></Grid>
							<Grid item xs={5.5} display="flex" justifyContent="center" alignItems="center"> */}
						{/* <Button
									// variant="outlined"
									color="error"
									sx={{ height: '25px', fontSize: '12px' }}
									onClick={handleClickOpen}
								>
									Delete Account
								</Button> */}
						{/* <Button
									variant="contained"
									color="primary"
									disabled={false}
									sx={{
										height: '35px',
										width: '100%',
										fontSize: '15px',
										borderRadius: 10
									}}
									onClick={() => {
										logoutUser();
										navigate('/home');
									}}
								>
									{Language.button.update}
								</Button>
							</Grid>
						</Grid> */}
						<Grid Grid container pt={2} >
							<Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
								<Button
									variant="outlined"
									startIcon={<LogoutIcon />}
									color="inherit"
									disabled={false}
									sx={{
										height: '35px',
										width: '100%',
										fontSize: '15px',
										borderRadius: 10
									}}
									onClick={() => {
										navigate('/logout');
									}}
								>
									{Language.heading.logout}
								</Button>
							</Grid>
						</Grid>
					</Grid>
					<Dialog
						open={open}
						TransitionComponent={Transition}
						keepMounted
						onClose={handleClose}
						aria-describedby="alert-dialog-slide-description"
					>
						<DialogTitle>{Language.message.are_you_sure_delete_account}</DialogTitle>
						<DialogContent>
							<DialogContentText>{Language.message.delete_acccount_warning}</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button variant={'contained'} onClick={handleClose}>
								{Language.button.cancel_goback}
							</Button>
							<Button variant={'contained'} color={'error'} onClick={callDeleteAccount}>
								{Language.button.confirm_delete}
							</Button>
						</DialogActions>
					</Dialog>
					<Dialog
						open={countryOpen}
						TransitionComponent={Transition}
						keepMounted
						onClose={handleClose}
						aria-describedby="alert-dialog-slide-description"
					>
						<DialogTitle>{Language.message.confirm_change_country}</DialogTitle>
						<DialogContent>
							<DialogContentText>{Language.message.change_country_warning}</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button variant={'contained'} onClick={handleClose}>
								{Language.button.cancel_goback}
							</Button>
							<Button variant={'contained'} color={'warning'} onClick={handleChangeCountry}>
								{Language.button.confirm_country_change}
							</Button>
						</DialogActions>
					</Dialog>
				</>
			)}
		</>
	);
};

export default MyAccount;
